import React, { useCallback, useState } from 'react';

const ReadOnlyView = ({ label, text, editText, handleClick }) => {
    return (
        <div className="rounded-xl bg-skin-light p-4">
            {label && <span className="text-sm">{label}</span>}
            {text && (
                <p className="font-semibold text-lg text-skin-dark">{text}</p>
            )}
            <a
                href="#"
                className="text-skin-primary text-xs"
                onClick={handleClick}
            >
                {editText ?? 'Edit'}
            </a>
        </div>
    );
};

const ToggleReadOnly = (props) => {
    const { label, text, editText, readonly, onChange } = props;

    const [readOnlyView, setReadOnlyView] = useState(readonly);

    const handleClick = useCallback((e) => {
        e.preventDefault();
        setReadOnlyView(!readOnlyView);
        if (onChange) onChange(!readOnlyView);
    }, []);

    if (readOnlyView) {
        return (
            <ReadOnlyView
                label={label}
                text={text}
                editText={editText}
                handleClick={handleClick}
            />
        );
    }

    return <>{props.children}</>;
};

export default ToggleReadOnly;
